import { EProgramApplianceCategory } from "@/domains/v4b/program/program.types";
import { EDay } from "@/utils/date";
import { TLocalTime } from "@/utils/time";

export interface GenericSubprogramRange {
  startTime: TLocalTime;
  endTime: TLocalTime;
  temperature: number | undefined | null;
}

export enum EHeaterProgramMetaMode {
  COMFORT = "CONFORT",
  ECO = "ECO",
  NO_FROST = "HORS_GEL",
}

export enum EProgrammingMetaMode {
  // Should not be defined by the backend, but we have a distinction to do in frontend
  PROGRAMMING = "PROGRAMMING",
}

export enum EBookableSpaceMetaMode {
  OCCUPIED = "OCCUPIED",
  AVAILABLE = "AVAILABLE",
}

export enum ECommonProgramMetaMode {
  TEMP = "TEMPERATURE",
  OFF = "OFF",
}

export enum EOnProgramMetaMode {
  ON = "ON",
}

export type TProgramMetaMode =
  | EOnProgramMetaMode
  | EHeaterProgramMetaMode.COMFORT
  | EHeaterProgramMetaMode.ECO
  | EHeaterProgramMetaMode.NO_FROST
  | ECommonProgramMetaMode.TEMP
  | ECommonProgramMetaMode.OFF
  | EBookableSpaceMetaMode.AVAILABLE
  | EBookableSpaceMetaMode.OCCUPIED
  | EProgrammingMetaMode;

export interface HeaterSubprogramRange extends GenericSubprogramRange {
  metaMode: EHeaterProgramMetaMode;
}

export interface BookableSpaceSubprogramRange extends GenericSubprogramRange {
  metaMode: EBookableSpaceMetaMode;
}

export interface OnSubprogramRange extends GenericSubprogramRange {
  metaMode: EOnProgramMetaMode;
}

export interface CommonSubprogramRange extends GenericSubprogramRange {
  metaMode: ECommonProgramMetaMode;
}

export type SubprogramRange =
  | HeaterSubprogramRange
  | BookableSpaceSubprogramRange
  | OnSubprogramRange
  | CommonSubprogramRange;

export type WeeklySubprogram = Record<EDay, SubprogramRange[]>;

export type SubprogramsByApplianceCategory = Partial<Record<EProgramApplianceCategory, WeeklySubprogram>>;

type SubprogramRequest = {
  ranges: WeeklySubprogram;
};

export type SubprogramsByApplianceCategoryRequest = Partial<Record<EProgramApplianceCategory, SubprogramRequest>>;
